<script setup lang="ts">
  import { ActionButtons } from '@/shared/ui';
  import { useCreateTraining } from '../model/useCreateTraining';
  import TrainingTypeRadioGroup from './TrainingTypeRadioGroup.vue';
  import OnboardingForm from './onboarding/OnboardingForm.vue';
  import RoleChangeForm from './role-change/RoleChangeForm.vue';
  import SgqPunctualForm from './sgq-punctual/SgqPunctualForm.vue';
  import OpenTrainingForm from './open-training/OpenTrainingForm.vue';

  const { selectedType, canSave, saving, save, onboarding, roleChange, sgqPunctual, openTraining } =
    useCreateTraining();
</script>

<template>
  <div
    data-testid="create-training-page"
    class="flex h-full flex-col gap-6 p-6"
  >
    <h1
      data-testid="create-training-title"
      class="text-xl font-semibold text-gray-07"
    >
      Criar treinamento
    </h1>

    <div class="flex flex-col rounded-2xl border border-gray-02 bg-white-01">
      <div
        class="flex flex-col gap-4 p-6"
        :class="{ 'border-b border-gray-02': selectedType !== null }"
      >
        <h2 class="text-sm font-semibold text-gray-07">
          Tipo de Treinamento
        </h2>
        <TrainingTypeRadioGroup v-model="selectedType" />
      </div>

      <OnboardingForm
        v-if="selectedType === 'ONBOARDING'"
        :form="onboarding"
      />
      <RoleChangeForm
        v-if="selectedType === 'ROLE_CHANGE'"
        :form="roleChange"
      />

      <SgqPunctualForm
        v-if="selectedType === 'SGQ_DOCUMENT_FOCAL'"
        :form="sgqPunctual"
      />

      <OpenTrainingForm
        v-if="selectedType === 'OPEN_TRAINING'"
        :form="openTraining"
      />
    </div>

    <div
      data-testid="create-training-actions"
      class="mt-auto"
    >
      <ActionButtons
        :cancel-route="{ name: 'TreinamentosListaTreinamentos' }"
        :disabled="!canSave"
        :loading="saving"
        @save="save"
      />
    </div>
  </div>
</template>
